import Swal from 'sweetalert2';

const Toast = Swal.mixin({
	toast: true,
	position: 'bottom-end',
	showConfirmButton: false,
	timer: 3500,
	timerProgressBar: true,
	didOpen: (toast) => {
		toast.addEventListener('mouseenter', Swal.stopTimer);
		toast.addEventListener('mouseleave', Swal.resumeTimer);
	},
});

export const toastSweet = (
	icon,
	message,
	seconds = 4,
	position = 'bottom-right'
) => {
	Toast.fire({
		icon: icon,
		title: message,
		timer: seconds * 1000,
		position: position,
	});
};

export const alertSweet = (icon, message, seconds = 4) => {
	Swal.fire({
		icon: icon,
		title: message,
		timer: seconds * 1000,
		timerProgressBar: true,
		showConfirmButton: false,
	});
};

export const confirmModal = (
	icon,
	title,
	text,
	buttonText = 'Aceptar',
	showCancelButton = true
) => {
	return Swal.fire({
		icon,
		title,
		text,
		showCancelButton,
		confirmButtonColor: '#183b65',
		confirmButtonText: buttonText,
		cancelButtonColor: '#d33',
		cancelButtonText: 'Cancelar',
	});
};

export const inputResetPassword = async () => {
	return await Swal.fire({
		title: 'Reestablecer contraseña',
		inputLabel: 'Te enviaremos un correo para que cambies tu contraseña',
		inputPlaceholder: 'Escribe tu correo electrónico',
		confirmButtonText: 'Enviar correo',
		focusConfirm: false,
		confirmButtonColor: '#183b65',
		preConfirm: async () => {
			const email = document.getElementById('email').value;

			if (email.length > 0) {
				return { email };
			} else {
				console.log('Faltan datos');
			}
		},
	});
};

export const inputTextModal = async (title, placeholder, helpText = '') => {
	return await Swal.fire({
		title: title,
		input: 'textarea',
		inputLabel: helpText,
		inputPlaceholder: placeholder,
		confirmButtonColor: '#084f93',
		returnFocus: false,
		showCancelButton: true,
		cancelButtonColor: '#d33',
		confirmButtonText: 'Continuar',
		cancelButtonText: 'Cancelar',
		inputValidator: (text) => {
			return new Promise((resolve, reject) => {
				if (text) {
					resolve();
				} else {
					reject('Texto no válido');
				}
			});
		},
	});
};
